export const CONSENT_VERSION = 'v1.0';

export const CONSENT_INTRO =
  '㈜에이지웰은 시니어헬퍼 서비스 제공 및 복지서비스 상담을 위해 아래와 같이 개인정보를 수집ㆍ이용합니다. 내용을 읽으신 후 동의 여부를 결정해 주세요.';

export const COMMON_SECTIONS = [
  {
    title: '[개인정보 수집ㆍ이용내역]',
    rows: [
      { label: '항목', value: '이름, 성별, 생년월일, 휴대전화번호, 주소, 가족관계, 가족동거여부, 보호자 이름, 보호자 휴대전화번호, 보호자와의 관계' },
      { label: '수집ㆍ이용목적', value: '시니어헬퍼 서비스 제공, 장기요양서비스(주간보호·방문요양) 상담 및 지원, 기초생활수급자 복지 서비스 상담 및 지원' },
      { label: '보유기간', value: '서비스 제공 후 3년' },
    ],
  },
  {
    title: '[민감정보 수집ㆍ이용내역]',
    rows: [
      { label: '항목', value: '건강정보, 장기요양보험등급, 기초생활수급자여부, 복용중인 약물' },
      { label: '수집ㆍ이용목적', value: '병원동행 서비스, 장기요양서비스(주간보호·방문요양) 상담 및 지원, 기초생활수급자 복지 서비스 상담 및 지원' },
      { label: '보유기간', value: '서비스 제공 후 3년' },
    ],
  },
  {
    title: '[개인정보 제3자 제공 내역]',
    rows: [
      { label: '제공받는 자', value: '㈜라파엘노인데이케어센터' },
      { label: '제공목적', value: '시니어헬퍼 서비스 상담, 장기요양서비스(주간보호·방문요양) 상담 및 지원, 기초생활수급자 복지 서비스 상담 및 지원' },
      { label: '제공항목', value: '이름, 성별, 생년월일, 휴대전화번호, 주소, 가족관계, 가족동거여부, 보호자 이름, 보호자 휴대전화번호, 보호자와의 관계, 건강정보, 장기요양보험등급, 기초생활수급자여부, 복용중인 약물' },
      { label: '보유기간', value: '서비스 제공 후 3년' },
    ],
  },
];

export const SELF_CONSENT_NOTICE =
  '귀하는 개인정보 수집ㆍ이용에 대한 동의를 거부할 권리가 있습니다. 다만, 동의를 거부하실 경우 서비스 이용에 제한이 있을 수 있습니다.';

export const GUARDIAN_CONSENT_NOTICE =
  '귀하는 위 대상자의 개인정보 수집ㆍ이용에 대한 동의를 거부할 권리가 있습니다. 다만, 동의를 거부하실 경우 서비스 이용에 제한이 있을 수 있습니다. 대상자의 개인정보를 수집ㆍ이용하는데 보호자로서 동의하십니까?';
